import { connectAPI } from "./api"
import env from "../env"
import { IConfiguration, IPackageDiff } from "../components/deployment"
import { IAddin } from "../components/addins"
const feedback = env.feedback

const baseUrl = "deployment"

export const getAddins = (filter?: string): Promise<IAddin[]> =>
    connectAPI.getJSON(`${baseUrl}/formulachangetracker/addins`, { filter })

export const getConfigurations = (): Promise<IConfiguration[]> =>
    connectAPI.getJSON(`${baseUrl}/configurations`)

export const getInstalledConfigurations = (): Promise<IConfiguration[]> =>
    connectAPI.getJSON(`${baseUrl}/installedConfigurations`)

export const exportConfiguration = (id: string): Promise<void> =>
    connectAPI.postVoid(
        `${baseUrl}/exportpackage?id=${id}&feedback=${feedback}`,
    )

export const removeConfiguration = (id: string): Promise<void> =>
    connectAPI.postVoid(`${baseUrl}/remove?id=${id}`)

export const getExample = (clean: boolean): Promise<string> =>
    connectAPI.getXML(`${baseUrl}/generate?clean=${clean}`)

export const getSource = (id: string): Promise<string> =>
    connectAPI.getXML(`${baseUrl}/configuration?id=${id}`)

export const saveSource = (source: string): Promise<void> =>
    connectAPI.postXML(`${baseUrl}/configuration`, source)

export const getPackageDiff = (id: string): Promise<IPackageDiff> =>
    connectAPI.getJSON(
        `${baseUrl}/ChangeTracker/PackageDiff?id=${id}&feedback=${feedback}`,
    )

export const makeSnapshot = (id: string): Promise<void> =>
    connectAPI.postVoid(
        `${baseUrl}/ChangeTracker/MakeSnapshot?id=${id}&feedback=${feedback}`,
    )

export const getPackageAddinDiffs = (id: string): Promise<IAddin[]> =>
    connectAPI.getJSON(`${baseUrl}/formulachangetracker/package?id=${id}`)
